import axios from 'axios';
import { clearAuth } from '../redux/slices/auth';
import { store } from '../redux/store';

export class ApiError extends Error {
  constructor(message, status, payload) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.payload = payload;
  }
}

const API_URL = process.env.REACT_APP_API_URL;


export const api = axios.create({
  baseURL: API_URL,
  timeout: 20_000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Response interceptor: нормализация ошибок
api.interceptors.response.use(
  (res) => res,
  (err) => {
    // axios error: err.response может быть undefined (например, network error)
    const status = err?.response?.status ?? 0;
    const payload = err?.response?.data ?? null;

    const message =
      (payload && typeof payload === 'object' && payload.message) ||
      err.message ||
      'Request failed';

      if (status === 401 && window.location.pathname !== '/') {
        store.dispatch(clearAuth());
        window.location.href = '/';
        return Promise.reject(new ApiError('Unauthorized', status, payload));
      }

    return Promise.reject(new ApiError(message, status, payload));
  }
);

// Обертка только для GET/POST
export const http = {
  get: (url, config) => {
    if (config?.queryParams) {
      const queryParamsList = Object.entries(config.queryParams).filter(([, value]) => {
        if (value === null || value === undefined) return false;
        if (Array.isArray(value)) {
          return value.length > 0;
        }
        if (typeof value === 'string') return value.trim().length > 0;
        if (typeof value === 'number') return Number.isFinite(value);
        if (typeof value === 'boolean') return true;
        return true;
      });
      if (queryParamsList.length > 0) {
        url += `?${queryParamsList.map(([key, value]) => {
          if (Array.isArray(value)) {
            const addapterKey = `${key}[]`;
            return value.map(v => `${addapterKey}=${v}`).join('&');
          }
          return `${key}=${value}`;
        }).join('&')}`;
      }
    }
    return api.get(url, config).then((r) => r.data);
  },
  post: (url, data, config) => api.post(url, data, config).then((r) => r.data),
};
